import React, { useState, useEffect } from "react";
import styled, { keyframes, css } from 'styled-components';
import { calc4k } from '../utilities';

const msPerPx = (base,px) => {
    return `${base * px}ms`;
};

export default function({ active, message, speed }) {

    const winWidth = window.innerWidth;
    const [textWidth,setTextWidth] = useState( 0 );
    const [marquees,setMarquees] = useState( [ 0 ] );

    useEffect( () => {
        const element = document.getElementById('marquee-0');
        setTextWidth( element.clientWidth );
    }, [] );

    return (
        <Marquee active={active}>
            {
                marquees.map( index => (
                    <MarqueeText id={ `marquee-${ index }` } index={ index + 1 } winWidth={ winWidth }
                                 key={`marquee-${index}`}
                                 speed={speed}
                                 textWidth={ textWidth } animate={active && textWidth}>
                        {message}
                    </MarqueeText>
                ) )
            }
        </Marquee>
    );
}

const Marquee = styled.div`
  width: 100%;
  top: ${calc4k(-35)};
  position: relative;
`;

const MarqueeText = styled.div`
    position: absolute;
    top: 0;
    left: 100%;
    white-space: nowrap;
    box-sizing: border-box;
    padding-right: ${calc4k(100)};

    &::after {
        position: absolute;
        top: 0;
        right: 0;
        width: ${calc4k(100)};
        text-align: center;
        display: inline-block;
        content: '•';
        box-sizing: border-box;
        padding: 0 ${calc4k(25)};
        display: none;
    }
    
    ${ p => p.animate ? screenAnimation : '' } 
`;

const acrossScreen = width => keyframes`
    0% {
        transform: translate3d( 0, 0, 0 );
    }
    
    100% {
        transform: translate3d( -${width + 200}px, 0, 0 ); 
    }
`;

const screenAnimation = css`
    animation: ${ p => {
        const totalDistance = p.winWidth + p.textWidth;
        return acrossScreen(totalDistance);
    }} ${ p => {
        const totalDistance = p.winWidth + p.textWidth;
        return msPerPx( p.speed, totalDistance);
}} linear infinite;
`;